import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  Modal,
  Select,
  Form,
  Alert,
  Button,
} from "antd";
import cx from "classnames";
import moment from "moment";
import styles from "./styles/OrderDetail.module.css";
import { selectUser } from "../redux/slices/user";
import ProductList from "./ProductList";
import OrderHeader from "./OrderHeader";
import OrderClientInfo from "./OrderClientInfo";
import OrderActionsSection from "./OrderActionsSection";

const OrderDetail = (props) => {
  const [drivers, handleDrivers] = useState([]);
  const [selectDriver, handleSelectedDriver] = useState(null);
  const [selectBranch, handleSelectedBranch] = useState(null);
  const [loading, handleLoading] = useState(true);
  const [sending, handleSending] = useState(false);
  const [assing, handleAssing] = useState(false);
  const [loadTransfer, handleLoadTransfer] = useState(false);
  const [deleting, handleDeleting] = useState(false);
  const [loadingDeta, handleLoadingOrder] = useState(false);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const isAdmin = user.admin;
  const isDriver = user.driver;
  const [form] = Form.useForm();

  const [sendingCireba, handleSendingCireba] = useState(false);

  const {
    order,
    monitor,
    acceptOrder,
    updateOrder,
    finishOrder,
    cancelOrder,
    assignOrder,
    sendPeya,
    getDriversBranch,
    branches,
    transferOrder,
    reasons,
    resendOrder,
  } = props;

  const {
    branch,
    status,
    platform,
    description,
    orderType,
    id_user,
    id_driver,
    delivery_address,
    address_info,
    discount,
    total,
    ticket,
    peyaOrder,
    products,
    cireba_remote_id,
    cireba_error,
    payment_method,
    change,
    cashback,
    delivery_fee,
    peyaStatus,
    peyaConfirmCode,
    peyaResult,
  } = order;

  const resendCirebaOrder = async () => {
    handleSendingCireba(true);
    await resendOrder();
    handleSendingCireba(false);
  };

  const isCash = payment_method === 1;

  useEffect(() => {
    const initialFetch = async () => {
      //BUSCAMOS DRIVER SOLAMENTE SI ES NECESARIO
      if (monitor && !isDriver && orderType == "2" && !peyaOrder && status >= 7 && status < 11) {
        const newDrivers = await getDriversBranch(branch.id, order.id);
        handleDrivers(newDrivers);
        handleLoading(false);
        if (id_driver) {
          handleSelectedDriver(id_driver.id);
        }
      }else{
        handleLoading(false);
      }
    };
    initialFetch();
  }, [order]);

  const spanish_peya = {
    CONFIRMED: "CONFIRMADA",
    IN_PROGRESS: "INICIADA",
    NEAR_PICKUP: "LLEGADA SUCURSAL",
    PICKED_UP: "EN CAMINO",
    NEAR_DROPOFF: "POR ENTREGAR",
    COMPLETED: "FINALIZADA",
    NOT_ACCEPTED: "NO ACEPTADO",
    CANCELLED: "CANCELADA"
  };

  const openDataCard = async (id, data) => {
    handleLoadingOrder(true);
    let jsonobj = JSON.parse(data);
    Modal.info({
      title: "JSON Tarjeta - " + id,
      content: (
        <div>
          <pre dangerouslySetInnerHTML={{ __html: syntaxHighlight(jsonobj) }} />
        </div>
      ),
      onOk() {},
    });
    handleLoadingOrder(false);
  };

  const syntaxHighlight = (json) => {
    if (typeof json != "string") {
      json = JSON.stringify(json, undefined, 2);
    }
    json = json
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    return json.replace(
      /(\"(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\\"])*\"(\s*:)?)|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
      (match) => {
        let cls = "number";
        if (/^\"/.test(match)) {
          cls = /:$/.test(match) ? "key" : "string";
        } else if (/true|false/.test(match)) {
          cls = "boolean";
        } else if (/null/.test(match)) {
          cls = "null";
        }
        return `<span class="${cls}">${match}</span>`;
      }
    );
  };

  const confirmModal = (title, content, okText, onOk) => {
    Modal.confirm({
      title,
      content,
      okText,
      cancelText: "Cancelar",
      onOk,
    });
  };

  const confirmCancel = () => {
    form.resetFields();
    Modal.confirm({
      title: "¿Estás segúro de cancelar esta orden?",
      content: (
        <Form layout="vertical" form={form}>
          <p>Esta acción no se podrá deshacer.</p>
          <Form.Item
            label="Seleccione la razón de cancelación:"
            name="reason"
            rules={[{ required: true, message: "Por favor seleccione una razón" }]}
          >
            <Select
              options={reasons.map((item) => ({ value: item.id, label: item.name }))}
              style={{ width: "250px" }}
            />
          </Form.Item>
        </Form>
      ),
      okText: "Cancelar orden",
      okType: "danger",
      cancelText: "No hacer nada",
      onOk() {
        return new Promise((resolve, reject) => {
          form.validateFields()
            .then((values) => {
              cancelMonitorOrder(values.reason);
              resolve();
            })
            .catch(reject);
        });
      },
    });
  };

  const confirmTransfer = () => {
    form.resetFields();
    Modal.confirm({
      title: "¿Estás segúro de Transferir esta orden?",
      content: (
        <Form layout="vertical" form={form}>
          <p>Esta acción no se podrá deshacer.</p>
          <Form.Item
            label="Seleccione la razón de traslado:"
            name="reason"
            rules={[{ required: true, message: "Por favor seleccione una razón" }]}
          >
            <Select
              options={reasons.map((item) => ({ value: item.id, label: item.name }))}
              style={{ width: "250px" }}
            />
          </Form.Item>
        </Form>
      ),
      okText: "Transferir orden",
      okType: "danger",
      cancelText: "No hacer nada",
      onOk: () => {
        return form.validateFields().then(async (values) => {
          handleLoadTransfer(true);
          try {
            await transferOrder(selectBranch, values.reason);
          } finally {
            handleLoadTransfer(false);
          }
        });
      },
    });
  };

  const accepMonitorOrder = async () => {
    handleSending(true);
    await acceptOrder();
    handleSending(false);
  };

  const updateMonitorOrder = async () => {
    handleSending(true);
    await updateOrder();
    handleSending(false);
  };

  const finishMonitorOrder = async () => {
    handleSending(true);
    await finishOrder();
    handleSending(false);
  };

  const cancelMonitorOrder = async (reason) => {
    handleDeleting(true);
    await cancelOrder(user.id, reason);
    handleDeleting(false);
  };

  const assingMonitorOrder = async () => {
    handleAssing(true);
    await assignOrder(selectDriver);
    handleAssing(false);
  };

  const confirmAcceptOrder = () => {
    confirmModal(
      "¿Estás segúro de colocar esta orden en preparación?",
      "Esta acción no se podrá deshacer.",
      "Orden en preparación",
      accepMonitorOrder
    );
  };

  const confirmUpdateOrder = () => {
    const title = orderType === "2"
      ? "¿Confirmar esta orden lista para enviar?"
      : "¿Estás segúro de colocar esta orden lista para recoger?";
    confirmModal(title, "Esta acción no se podrá deshacer.", "Orden lista", updateMonitorOrder);
  };

  const confirmFinishOrder = () => {
    confirmModal("¿Estás segúro de finalizar esta orden?", "Esta acción no se podrá deshacer.", "Orden finalizada", finishMonitorOrder);
  };

  return (
    <div className={styles.order}>
      <Row>
        <Col xs={24}>
          <OrderHeader status={status} orderType={orderType} ticket={ticket} />
        </Col>
      </Row>

      <Row>
        <Col xs={24}>
          {id_user && (
            <OrderClientInfo
              id_user={id_user}
              orderType={orderType}
              address_info={address_info}
              delivery_address={delivery_address}
              branch={branch}
            />
          )}
        </Col>
      </Row>

      {(!cireba_remote_id || cireba_remote_id === "0") && order.status !== 6 && order.status !== 20 && (
        <div className={styles.warning}>
          <Alert
            message="No ingresada a CIREBA"
            description={cireba_error || undefined}
            showIcon
            type="warning"
            action={
              <Button
                size="small"
                danger
                loading={sendingCireba}
                onClick={resendCirebaOrder}
              >
                Reenviar orden
              </Button>
            }
          />
        </div>
      )}

      <div className={styles.body}>
        <Row gutter={20}>
          <Col xs={24} lg={12}>
            <ProductList products={products} loadingDeta={loadingDeta} openDataCard={openDataCard} />

            {(platform === "ubereats" || platform === "pedidosya") && description && (
              <div className={styles.annotations}>
                <span>
                  <span className={styles.labelNotes}>Notas:</span> {description.replace("[UBER]", "")}
                </span>
              </div>
            )}

            {orderType === "2" && (
              <div className={styles.totalInfo}>
                <div className={styles.deliveryWrap}>
                  <span className={styles.label}>ENVÍO A DOMICILIO:</span>
                  <span className={styles.price}>{`$ ${parseFloat(delivery_fee).toFixed(2)}`}</span>
                </div>
              </div>
            )}

            {parseFloat(discount) > 0 && (
              <div className={styles.tipWrap}>
                <span className={styles.label}>DESCUENTO:</span>
                <span className={styles.price}>{`- ($ ${parseFloat(discount).toFixed(2)})`}</span>
              </div>
            )}

            <div className={styles.totalInfo}>
              <div className={styles.totalWrap}>
                <span className={styles.label}>TOTAL DE COMPRA</span>
                <span className={cx(styles.totalPrice, styles.green)}>
                  {`$ ${parseFloat(total).toFixed(2)}`}
                </span>
              </div>
            </div>
          </Col>

          <OrderActionsSection
            styles={styles}
            isCash={isCash}
            cashback={cashback}
            change={change}
            total={total}
            monitor={monitor}
            isAdmin={isAdmin}
            status={status}
            loading={loading}
            selectBranch={selectBranch}
            handleSelectedBranch={handleSelectedBranch}
            confirmTransfer={confirmTransfer}
            branches={branches}
            isDriver={isDriver}
            orderType={orderType}
            peyaOrder={peyaOrder}
            order={order}
            drivers={drivers}
            selectDriver={selectDriver}
            handleSelectedDriver={handleSelectedDriver}
            assingMonitorOrder={assingMonitorOrder}
            assing={assing}
            id_driver={id_driver}
            sendPeya={sendPeya}
            peyaConfirmCode={peyaConfirmCode}
            peyaStatus={peyaStatus}
            peyaResult={peyaResult}
            spanish_peya={spanish_peya}
            confirmCancel={confirmCancel}
            confirmAcceptOrder={confirmAcceptOrder}
            confirmUpdateOrder={confirmUpdateOrder}
            confirmFinishOrder={confirmFinishOrder}
            deleting={deleting}
            sending={sending}
          />
        </Row>
      </div>
    </div>
  );
};

export default OrderDetail;
